import './style.scss'
import { showOrderPopup } from '../../../js/components/popups'

export default !function () {
  const blocks = document.querySelectorAll('.universal-internship-v1')

  if (!blocks.length) {
    return
  }

  blocks.forEach((block) => {
    const blockName = block.closest('[data-block-name]')?.dataset.blockName || 'Блок без названия'
    const actionButton = block.querySelector('.universal-internship-v1__button')

    actionButton?.addEventListener('click', () => {
      if (actionButton.dataset.actionButton === 'order-modal') {
        showOrderPopup(blockName)
      }

      const buttonType = actionButton.dataset.actionButton || (actionButton.dataset.redirectLink && 'redirect')

      buttonType && window.$analytics?.push('all-block-consult-button-click', {
        blockName,
        buttonType,
        buttonText: actionButton.textContent
      })
    })
  })
}()
